//Core
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
//Types
import { TSideBarNavigation } from "@/types/navigation/navigationTypes";
//Redux
import { useSelector } from "react-redux";
import { userSelector } from "@/redux/user/userSelector";
//Hooks
import useMixpanel from "@/utils/hooks/useMixPanel";
import {MixpanelItems} from "@/utils/mixpanelItems";

export const useSideBarButtons = () => {
  const { pixelStatus } = useSelector(userSelector);
  const { isAuthenticated } = useAuth0();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { trackEvent } = useMixpanel();

  const activePath = pathname.split("/")[1];

  const openPage = (path: TSideBarNavigation) => {
    if (path === "files") {
      trackEvent(MixpanelItems.EnterUploadFilePage);
    } else if (path === "filter") {
      trackEvent(MixpanelItems.EnterGeneralAudiencePage);
    } else if (path === "custom") {
      trackEvent(MixpanelItems.EnterCustomAudiencePage);
    }
    if (isAuthenticated) {
      navigate(`/${path}`);
    } else {
      navigate('/login')
      localStorage.setItem('navigation', `/${path}`)
    }

  };

  return {
    activePath: activePath as TSideBarNavigation,
    openPage,
    pixelStatus,
    isAuthenticated,
  };
};
